import {
  ConfluenceSpaceAriResourceOwner,
  ConfluenceSpaceAriResourceType
} from "./chunk-UOPZEJBG.mjs";
import {
  RegisteredAri
} from "./chunk-AB4PPISI.mjs";
import {
  AriParser
} from "./chunk-S7RIZVFI.mjs";

// src/confluence/space/manifest.ts
var confluenceSpaceAriStaticOpts = {
  qualifier: "ari",
  platformQualifier: "cloud",
  cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
  // eslint-disable-line no-useless-escape
  resourceOwner: ConfluenceSpaceAriResourceOwner,
  resourceType: ConfluenceSpaceAriResourceType,
  resourceIdSlug: "{spaceId}",
  resourceIdSegmentFormats: {
    spaceId: /[0-9]+/
    // eslint-disable-line no-useless-escape
  }
};

// src/confluence/space/index.ts
var ConfluenceSpaceAri = class _ConfluenceSpaceAri extends RegisteredAri {
  constructor(opts) {
    super(opts);
    this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
  }
  get siteId() {
    return this._siteId;
  }
  get spaceId() {
    return this._spaceId;
  }
  static create(opts) {
    let derivedOpts = {
      qualifier: confluenceSpaceAriStaticOpts.qualifier,
      platformQualifier: confluenceSpaceAriStaticOpts.platformQualifier,
      cloudId: opts.siteId,
      resourceOwner: confluenceSpaceAriStaticOpts.resourceOwner,
      resourceType: confluenceSpaceAriStaticOpts.resourceType,
      resourceId: `${opts.spaceId}`,
      resourceIdSegmentValues: {
        spaceId: opts.spaceId
      }
    }, ariOpts = AriParser.fromOpts(derivedOpts, confluenceSpaceAriStaticOpts);
    return new _ConfluenceSpaceAri(ariOpts);
  }
  static parse(maybeAri) {
    let opts = AriParser.fromString(maybeAri, confluenceSpaceAriStaticOpts);
    return new _ConfluenceSpaceAri(opts);
  }
  getVariables() {
    return {
      siteId: this.siteId,
      spaceId: this.spaceId
    };
  }
};

export {
  ConfluenceSpaceAri
};
